import React, { Component } from "react";
import PropTypes from "prop-types";

import { Mutation } from "react-apollo";
import { Fieldset, Field, Control, Input, Label, Textarea } from "rbx";

import Section from "../Section";
import {
  BooleanInput,
  CustomerSelect,
  EditFormButtonGroup,
  LocationSelect,
  SystemCodeSelect
} from "../inputs";

import {
  UPDATE_ROUTE_MUTATION,
  DELETE_ROUTE_MUTATION
} from "../../graphql/Routes/Routes.graphql";
import { ErrorMessage } from "../ErrorMessage";

class EditRouteForm extends Component {
  state = {
    CustomerRecIdRef: "",
    RouteId: "",
    RouteDescription: "",
    Contract: "",
    PaymentMethodRecIfRef: "",
    StartLocationRecIdRef: "",
    PickupLocationRecIdRef: "",
    DeliveryLocationRecIdRef: "",
    EndingLocationRecIdRef: "",
    LoadTypeRecIdRef: "",
    IndustrialFlag: "",
    MotorOilFlag: "",
    LoadedMiles: "",
    Mileage: "",
    ChargeForTolls: "",
    Tolls: "",
    Times: "",
    LoadTime: "",
    TravelTime: "",
    UnloadTime: "",
    ReturnToTerminalTime: "",
    UnloadedMiles: "",
    NonBill: false,
    ...this.props.route
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.currentTarget.value });
  };

  render() {
    const {
      CustomerRecIdRef,
      RouteId,
      RouteDescription,
      Contract,
      PaymentMethodRecIfRef,
      StartLocationRecIdRef,
      PickupLocationRecIdRef,
      DeliveryLocationRecIdRef,
      EndingLocationRecIdRef,
      LoadTypeRecIdRef,
      IndustrialFlag,
      MotorOilFlag,
      LoadedMiles,
      Mileage,
      ChargeForTolls,
      Tolls,
      Times,
      LoadTime,
      TravelTime,
      UnloadTime,
      ReturnToTerminalTime,
      UnloadedMiles,
      NonBill
    } = this.state;

    const { onComplete } = this.props;
    return (
      <Mutation
        mutation={UPDATE_ROUTE_MUTATION}
        refetchQueries={["ALL_ROUTES_QUERY"]}
        variables={{
          data: {
            CustomerRecIdRef: parseInt(CustomerRecIdRef),
            RouteId,
            RouteDescription,
            Contract,
            NonBill,
            PaymentMethodRecIfRef: parseInt(PaymentMethodRecIfRef),
            StartLocationRecIdRef: parseInt(StartLocationRecIdRef),
            PickupLocationRecIdRef: parseInt(PickupLocationRecIdRef),
            DeliveryLocationRecIdRef: parseInt(DeliveryLocationRecIdRef),
            EndingLocationRecIdRef: parseInt(EndingLocationRecIdRef),
            LoadTypeRecIdRef: parseInt(LoadTypeRecIdRef),
            IndustrialFlag,
            MotorOilFlag,
            LoadedMiles: LoadedMiles ? parseFloat(LoadedMiles) : null,
            UnloadedMiles: UnloadedMiles ? parseFloat(UnloadedMiles) : null,
            Mileage,
            ChargeForTolls,
            Tolls,
            Times,
            TravelTime,
            LoadTime: LoadTime ? parseFloat(LoadTime) : null,
            UnloadTime: UnloadTime ? parseFloat(UnloadTime) : null,
            ReturnToTerminalTime
          },
          where: {
            RecId: this.props.route.RecId
          }
        }}
      >
        {(updateRoute, { loading, error }) => (
          <Section size="small" title="Edit Route">
            <form
              id="edit-route"
              method="POST"
              onSubmit={async e => {
                e.preventDefault();
                await updateRoute();
                onComplete();
              }}
            >
              <ErrorMessage error={error} />
              <Fieldset aria-busy={loading}>
                <Field kind="group">
                  <Control>
                    <Label>Route Id</Label>
                    <Input
                      autocomplete="new"
                      name="RouteId"
                      type="number"
                      value={RouteId}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <CustomerSelect
                      icon="globe"
                      label="Customer"
                      name="CustomerRecIdRef"
                      value={CustomerRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <Label>Route Description</Label>
                    <Textarea
                      name="RouteDescription"
                      rows="3"
                      value={RouteDescription}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <Label>Contract</Label>
                    <Input
                      autocomplete="new"
                      name="Contract"
                      type="text"
                      value={Contract}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <SystemCodeSelect
                      icon="globe"
                      label="Payment Method"
                      lookup={{ Category: "Route", Code: "PaymentMethod" }}
                      name="PaymentMethodRecIfRef"
                      value={PaymentMethodRecIfRef}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control expanded>
                    <LocationSelect
                      icon="globe"
                      label="Start Location"
                      name="StartLocationRecIdRef"
                      value={StartLocationRecIdRef}
                      onChange={this.onChange}
                    />

                    <LocationSelect
                      icon="globe"
                      label="Pickup Location"
                      name="PickupLocationRecIdRef"
                      value={PickupLocationRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <LocationSelect
                      icon="globe"
                      label="Delivery Location"
                      name="DeliveryLocationRecIdRef"
                      value={DeliveryLocationRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <LocationSelect
                      icon="globe"
                      label="Ending Location"
                      name="EndingLocationRecIdRef"
                      value={EndingLocationRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <SystemCodeSelect
                      icon="globe"
                      label="Load Type"
                      lookup={{ Category: "Route", Code: "LoadType" }}
                      name="LoadTypeRecIdRef"
                      value={LoadTypeRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control>
                    <Label>Industrial</Label>
                    <BooleanInput
                      name="IndustrialFlag"
                      value={IndustrialFlag}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Motor Oil</Label>
                    <BooleanInput
                      name="MotorOilFlag"
                      value={MotorOilFlag}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Loaded Miles</Label>
                    <Input
                      autocomplete="new"
                      name="LoadedMiles"
                      type="number"
                      value={LoadedMiles}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Mileage</Label>
                    <Input
                      autocomplete="new"
                      name="Mileage"
                      type="number"
                      value={Mileage}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control>
                    <Label>Charge For Tolls</Label>
                    <BooleanInput
                      name="ChargeForTolls"
                      value={ChargeForTolls}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Tolls</Label>
                    <Input
                      autocomplete="new"
                      name="Tolls"
                      type="number"
                      value={Tolls}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control expanded>
                    <Label>Load Time</Label>
                    <Input
                      autocomplete="new"
                      name="LoadTime"
                      type="number"
                      value={LoadTime}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Travel Time</Label>
                    <Input
                      autocomplete="new"
                      name="TravelTime"
                      type="number"
                      value={TravelTime}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control expanded>
                    <Label>Unload Time</Label>
                    <Input
                      autocomplete="new"
                      name="UnloadTime"
                      type="number"
                      value={UnloadTime}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Return Time</Label>
                    <Input
                      autocomplete="new"
                      name="ReturnToTerminalTime"
                      type="number"
                      value={ReturnToTerminalTime}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <EditFormButtonGroup
                  deleteMutation={DELETE_ROUTE_MUTATION}
                  form="edit-route"
                  refetchQueries={["ALL_ROUTES_QUERY"]}
                  variables={{ where: { RecId: this.props.route.RecId } }}
                  onComplete={onComplete}
                />
              </Fieldset>
            </form>
          </Section>
        )}
      </Mutation>
    );
  }
}

EditRouteForm.propTypes = {
  onComplete: PropTypes.func,
  route: PropTypes.object
};

export default EditRouteForm;
